/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetAttentionQueueParams,
  TrainWithMeModulesAttentionDtosRequestsRecordAttentionResponseRequest,
  TrainWithMeModulesAttentionDtosRequestsSetAttentionPreferenceRequest,
  TrainWithMeModulesAttentionDtosResponsesAttentionPreferenceAcknowledgement,
  TrainWithMeModulesAttentionDtosResponsesAttentionPreferencesResponse,
  TrainWithMeModulesAttentionDtosResponsesAttentionQueueResponse,
  TrainWithMeModulesAttentionDtosResponsesAttentionResponseAcknowledgement
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAttentionQueue = (
    params?: GetAttentionQueueParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAttentionDtosResponsesAttentionQueueResponse>(
      {url: `/attention-queue`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAttentionQueueQueryKey = (params?: GetAttentionQueueParams,) => {
    return [
    `/attention-queue`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAttentionQueueQueryOptions = <TData = Awaited<ReturnType<typeof getAttentionQueue>>, TError = ErrorType<unknown>>(params?: GetAttentionQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttentionQueueQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttentionQueue>>> = ({ signal }) => getAttentionQueue(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttentionQueueQueryResult = NonNullable<Awaited<ReturnType<typeof getAttentionQueue>>>
export type GetAttentionQueueQueryError = ErrorType<unknown>


export function useGetAttentionQueue<TData = Awaited<ReturnType<typeof getAttentionQueue>>, TError = ErrorType<unknown>>(
 params: undefined |  GetAttentionQueueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttentionQueue>>,
          TError,
          Awaited<ReturnType<typeof getAttentionQueue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttentionQueue<TData = Awaited<ReturnType<typeof getAttentionQueue>>, TError = ErrorType<unknown>>(
 params?: GetAttentionQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttentionQueue>>,
          TError,
          Awaited<ReturnType<typeof getAttentionQueue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttentionQueue<TData = Awaited<ReturnType<typeof getAttentionQueue>>, TError = ErrorType<unknown>>(
 params?: GetAttentionQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAttentionQueue<TData = Awaited<ReturnType<typeof getAttentionQueue>>, TError = ErrorType<unknown>>(
 params?: GetAttentionQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttentionQueueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAttentionQueuePreferences = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAttentionDtosResponsesAttentionPreferencesResponse>(
      {url: `/attention-queue/preferences`, method: 'GET', signal
    },
      options);
    }




export const getGetAttentionQueuePreferencesQueryKey = () => {
    return [
    `/attention-queue/preferences`
    ] as const;
    }


export const getGetAttentionQueuePreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttentionQueuePreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttentionQueuePreferences>>> = ({ signal }) => getAttentionQueuePreferences(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttentionQueuePreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getAttentionQueuePreferences>>>
export type GetAttentionQueuePreferencesQueryError = ErrorType<unknown>


export function useGetAttentionQueuePreferences<TData = Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttentionQueuePreferences>>,
          TError,
          Awaited<ReturnType<typeof getAttentionQueuePreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttentionQueuePreferences<TData = Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttentionQueuePreferences>>,
          TError,
          Awaited<ReturnType<typeof getAttentionQueuePreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttentionQueuePreferences<TData = Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAttentionQueuePreferences<TData = Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttentionQueuePreferences>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttentionQueuePreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putAttentionQueuePreferences = (
    trainWithMeModulesAttentionDtosRequestsSetAttentionPreferenceRequest?: BodyType<TrainWithMeModulesAttentionDtosRequestsSetAttentionPreferenceRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAttentionDtosResponsesAttentionPreferenceAcknowledgement>(
      {url: `/attention-queue/preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesAttentionDtosRequestsSetAttentionPreferenceRequest, signal
    },
      options);
    }




export const getPutAttentionQueuePreferencesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAttentionQueuePreferences>>, TError,{data?: BodyType<TrainWithMeModulesAttentionDtosRequestsSetAttentionPreferenceRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putAttentionQueuePreferences>>, TError,{data?: BodyType<TrainWithMeModulesAttentionDtosRequestsSetAttentionPreferenceRequest>}, TContext> => {

const mutationKey = ['putAttentionQueuePreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAttentionQueuePreferences>>, {data?: BodyType<TrainWithMeModulesAttentionDtosRequestsSetAttentionPreferenceRequest>}> = (props) => {
          const {data} = props ?? {};

          return  putAttentionQueuePreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutAttentionQueuePreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof putAttentionQueuePreferences>>>
    export type PutAttentionQueuePreferencesMutationBody = BodyType<TrainWithMeModulesAttentionDtosRequestsSetAttentionPreferenceRequest> | undefined
    export type PutAttentionQueuePreferencesMutationError = ErrorType<unknown>

    export const usePutAttentionQueuePreferences = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAttentionQueuePreferences>>, TError,{data?: BodyType<TrainWithMeModulesAttentionDtosRequestsSetAttentionPreferenceRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAttentionQueuePreferences>>,
        TError,
        {data?: BodyType<TrainWithMeModulesAttentionDtosRequestsSetAttentionPreferenceRequest>},
        TContext
      > => {
      return useMutation(getPutAttentionQueuePreferencesMutationOptions(options), queryClient);
    }
    export const postAttentionQueueResponses = (
    trainWithMeModulesAttentionDtosRequestsRecordAttentionResponseRequest?: BodyType<TrainWithMeModulesAttentionDtosRequestsRecordAttentionResponseRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesAttentionDtosResponsesAttentionResponseAcknowledgement>(
      {url: `/attention-queue/responses`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesAttentionDtosRequestsRecordAttentionResponseRequest, signal
    },
      options);
    }




export const getPostAttentionQueueResponsesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttentionQueueResponses>>, TError,{data?: BodyType<TrainWithMeModulesAttentionDtosRequestsRecordAttentionResponseRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAttentionQueueResponses>>, TError,{data?: BodyType<TrainWithMeModulesAttentionDtosRequestsRecordAttentionResponseRequest>}, TContext> => {

const mutationKey = ['postAttentionQueueResponses'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAttentionQueueResponses>>, {data?: BodyType<TrainWithMeModulesAttentionDtosRequestsRecordAttentionResponseRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postAttentionQueueResponses(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAttentionQueueResponsesMutationResult = NonNullable<Awaited<ReturnType<typeof postAttentionQueueResponses>>>
    export type PostAttentionQueueResponsesMutationBody = BodyType<TrainWithMeModulesAttentionDtosRequestsRecordAttentionResponseRequest> | undefined
    export type PostAttentionQueueResponsesMutationError = ErrorType<unknown>

    export const usePostAttentionQueueResponses = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttentionQueueResponses>>, TError,{data?: BodyType<TrainWithMeModulesAttentionDtosRequestsRecordAttentionResponseRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAttentionQueueResponses>>,
        TError,
        {data?: BodyType<TrainWithMeModulesAttentionDtosRequestsRecordAttentionResponseRequest>},
        TContext
      > => {
      return useMutation(getPostAttentionQueueResponsesMutationOptions(options), queryClient);
    }
